export * from './loyalty-rewards.styled.default';
